/* eslint-disable react/destructuring-assignment */
import React from "react";
import { node } from "prop-types";
import GridTable from "pages/_components/GridTable/GridTable";
import CustomText from "pages/_components/CustomText/CustomText";
// import FormattedAmount from "pages/_components/FormattedAmount";

const IndicatorsDetailCreditBills = ({ data }) => {
    const handleBoleanValues = (value) => {
        let dataValue;
        if (value) {
            dataValue = "Si";
        } else {
            dataValue = "No";
        }
        return dataValue;
    };
    return (
        <>
            <GridTable>
                <GridTable.Container columns={3} rows={4}>
                    <GridTable.Data columnStart={1} rowStart={1}>
                        <GridTable.Container columns={1} rows={1} className="mb-4">
                            <GridTable.Data rowStart={1}>
                                <CustomText textType="I18N" text="credit.bills.solicit.deal" />
                            </GridTable.Data>
                            <GridTable.Data rowStart={2}>
                                <CustomText
                                    className="data-label"
                                    text={handleBoleanValues(data?.solicitandoAcuerdo)}
                                />
                            </GridTable.Data>
                        </GridTable.Container>
                    </GridTable.Data>

                    <GridTable.Data columnStart={2} rowStart={1}>
                        <GridTable.Container columns={1} rows={1} className="mb-4">
                            <GridTable.Data rowStart={1}>
                                <CustomText textType="I18N" text="credit.bills.payment.prosses" />
                            </GridTable.Data>
                            <GridTable.Data rowStart={2}>
                                <CustomText className="data-label" text={handleBoleanValues(data?.enProcesoPago)} />
                            </GridTable.Data>
                        </GridTable.Container>
                    </GridTable.Data>

                    <GridTable.Data columnStart={3} rowStart={1}>
                        <GridTable.Container columns={1} rows={1} className="mb-4">
                            <GridTable.Data rowStart={1}>
                                <CustomText textType="I18N" text="credit.bills.emited.cal" />
                            </GridTable.Data>
                            <GridTable.Data rowStart={2}>
                                <CustomText className="data-label" text={handleBoleanValues(data?.calEmitido)} />
                            </GridTable.Data>
                        </GridTable.Container>
                    </GridTable.Data>

                    <GridTable.Data columnStart={1} rowStart={2}>
                        <GridTable.Container columns={1} rows={1} className="mb-4">
                            <GridTable.Data rowStart={1}>
                                <CustomText textType="I18N" text="credit.bills.payment.deal" />
                            </GridTable.Data>
                            <GridTable.Data rowStart={2}>
                                <CustomText className="data-label" text={handleBoleanValues(!data?.acuerdoRechazado)} />
                            </GridTable.Data>
                        </GridTable.Container>
                    </GridTable.Data>

                    <GridTable.Data columnStart={2} rowStart={2}>
                        <GridTable.Container columns={1} rows={1} className="mb-4">
                            <GridTable.Data rowStart={1}>
                                <CustomText textType="I18N" text="credit.bills.negotiation" />
                            </GridTable.Data>
                            <GridTable.Data rowStart={2}>
                                <CustomText
                                    className="data-label"
                                    text={handleBoleanValues(data?.enNegociacionImpaga)}
                                />
                            </GridTable.Data>
                        </GridTable.Container>
                    </GridTable.Data>

                    {data?.calEmitido && (
                        <GridTable.Data columnStart={3} rowStart={2}>
                            <GridTable.Container columns={1} rows={1} className="mb-4">
                                <GridTable.Data rowStart={1}>
                                    <CustomText textType="I18N" text="credit.bills.cal.code" />
                                </GridTable.Data>
                                <GridTable.Data rowStart={2}>
                                    <CustomText className="data-label" text={`${data?.codCal}`} />
                                </GridTable.Data>
                            </GridTable.Container>
                        </GridTable.Data>
                    )}

                    <GridTable.Data columnStart={data?.calEmitido ? 1 : 3} rowStart={data?.calEmitido ? 3 : 2}>
                        <GridTable.Container columns={1} rows={1} className="mb-4">
                            <GridTable.Data rowStart={1}>
                                <CustomText textType="I18N" text="credit.bills.forward.payment" />
                            </GridTable.Data>
                            <GridTable.Data rowStart={2}>
                                <CustomText
                                    className="data-label"
                                    text={handleBoleanValues(data?.facturaPagoAnticipado)}
                                />
                            </GridTable.Data>
                        </GridTable.Container>
                    </GridTable.Data>
                </GridTable.Container>
            </GridTable>
        </>
    );
};

IndicatorsDetailCreditBills.propTypes = {
    data: node.isRequired,
};

export default IndicatorsDetailCreditBills;
